export const ModalActionTypes = {
  TOGGLE_MODAL_HIDDEN: "TOGGLE_MODAL_HIDDEN",
};
